<template>
  <b-dropdown
    :close-on-click="false"
    ref="fileUploadDropdown"
    :mobile-modal="false"
    :disabled="disabled"
  >
    <template #trigger>
      <b-button
        :disabled="disabled || computedIsOffline"
        icon-left="text-box-search-outline"
        >{{ $t('ocr') }}</b-button
      >
    </template>

    <b-dropdown-item
      @click.native="onFileChooseClick"
      class="custom-dropdown-item"
    >
      <label class="file-upload">
        <input
          class="file-input"
          ref="imageUpload"
          type="file"
          multiple
          accept="image/*;capture=camera"
          @change="handleFileChooserChange"
        />
        <span class="mdi mdi-folder mdi-48px"> {{ $t('choose_files') }}</span>
      </label>
    </b-dropdown-item>
    <b-dropdown-item
      class="custom-dropdown-item"
      v-if="!this.$route.name.includes('editor')"
      @click.native="onDocumentsModal"
    >
      <div class="dij-diagrambuilder-file-chooser camera">
        <b-icon icon="file-document-arrow-right" size="is-large" />
        {{ $t('documents') }}
      </div>
    </b-dropdown-item>
    <b-dropdown-item class="custom-dropdown-item" @click.native="showCamera()">
      <div class="dij-diagrambuilder-file-chooser camera">
        <b-icon icon="camera" size="is-large" />
        {{ $t('take_photo') }}
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import OfflineMixin from '../../mixins/OfflineMixin';

export default {
  name: 'ocr-file-select',
  mixins: [OfflineMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    async onFileChooseClick(event) {
      if (await this.preventOfflineAction()) {
        event.preventDefault();
      }
    },
    async handleFileChooserChange(event) {
      if (await this.preventOfflineAction()) {
        return;
      }
      console.log('open');
      this.$emit('onFileChange', event.srcElement.files[0]);
      this.$refs.fileUploadDropdown.toggle();
      this.$refs.imageUpload.value = null;
    },
    async onDocumentsModal() {
      if (await this.preventOfflineAction()) {
        return;
      }

      this.$emit('onDocumentsModal');
    },
    async showCamera() {
      if (await this.preventOfflineAction()) {
        return;
      }
      this.$emit('showCamera');
    },
    onInputClick() {
      this.$refs.imageUpload.disabled = false;
      this.$refs.imageUpload.click();
      this.$refs.imageUpload.disabled = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.dij-diagrambuilder-file-chooser {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.dij-diagrambuilder-file-chooser {
  border: none !important;
  align-items: center;
}
.dij-diagrambuilder-file-chooser input[type='file'] {
  width: 48px;
  height: 48px;
  overflow: hidden;
}

.file-upload {
  cursor: pointer;
}

.camera {
  font-family: 'Siemens Sans';
  color: black;
}

.file-input {
  cursor: pointer;
}
</style>
